import { TranslateService } from '@ngx-translate/core';
import { RecurrenceService, recurrenceTypes } from '../recurrence.service';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Input,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Recurrence, Organization } from '../../shared/sdk/models';
import * as moment from 'moment';
import { OrganizationService } from '../../organizations/organization.service';
import { AccountService } from '../../accounts/account.service';
import { MyDpDateService } from '../../shared/services/my-dp-date.service';
import { NgbDateStruct, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-recurrence-add',
  templateUrl: './recurrence-add.component.html',
  styleUrls: ['./recurrence-add.component.css'],
})
export class RecurrenceAddComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @Input() recurrence: Recurrence;
  @Input() documentType: string;
  @ViewChild('recurrenceName', { static: true }) recurrenceName: ElementRef;
  dateFirst: string;
  dateMin: NgbDateStruct;
  recurrenceForm: FormGroup;
  recurrenceTypes: any;
  loading: boolean;
  sent: boolean;
  private activeOrg: Organization;
  private subscription$: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private recurrenceService: RecurrenceService,
    private orgService: OrganizationService,
    private translate: TranslateService,
    private accountService: AccountService,
    private fb: FormBuilder,
    private dateService: MyDpDateService,
  ) {}

  disableDay = (
    date: NgbDateStruct,
    current: { year: number; month: number },
  ) => {
    const today = this.dateService.generate(moment());
    return (
      today.year === date.year &&
      today.month === date.month &&
      date.day <= today.day
    );
  };

  ngOnInit() {
    this.dateMin = this.dateService.generate(moment().add(1, 'day'));
    this.recurrenceTypes = recurrenceTypes;

    for (const type of this.recurrenceTypes) {
      this.translate.get(type.name).subscribe((res) => (type.name = res));
    }

    // Form control
    this.recurrenceForm = this.fb.group({
      id: [],
      name: ['', Validators.required],
      documentId: [this.recurrence.documentId, Validators.required],
      dateFirst: [this.dateService.generate(moment().add(1, 'month'))],
      type: ['month', Validators.required],
      numRecurrences: [11, Validators.required],
      organizationId: [],
      accountId: [], // Should be auto populated on API
      saveAsDraft: [true],
      autoSend: [false],
      custom: [],
    });

    if (!this.recurrence.id) {
      this.recurrence = new Recurrence();
      this.recurrenceForm.controls['accountId'].setValue(
        this.accountService.getToken().userId,
      );
    } else {
      this.recurrence = new Recurrence(this.recurrence);
      this.recurrenceForm.patchValue(this.recurrence);
      this.recurrenceForm.controls['dateFirst'].patchValue(
        this.dateService.generate(moment(this.recurrence.dateFirst)),
      );
    }

    this.subscription$ = this.orgService.active
      .pipe(
        filter((org) => !!org),
      )
      .subscribe(
        (org: Organization) => {
          this.activeOrg = org;
          this.recurrenceForm.controls['organizationId'].setValue(org.id);
        },
      );
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => this.recurrenceName.nativeElement.focus(), 100);
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.recurrenceForm.valid) {
      this.loading = true;
      this.recurrence = this.recurrenceForm.value;
      this.recurrence.dateFirst = this.dateService.parse(
        this.recurrence.dateFirst,
      );

      this.recurrenceService[!this.recurrence.id ? 'create' : 'update'](
        this.recurrence.id || this.recurrence.documentId,
        this.recurrence,
      ).subscribe(
        (recurrence: Recurrence) => {
          this.loading = false;
          this.activeModal.close(recurrence);
        },
        (err) => {
          this.loading = false;
        },
      );
    }
  }
}
